import React from "react";

export default function MetadataLabel({ labelText }) {
  return <span class="u-tag">{labelText}</span>;
}
